import { render, staticRenderFns } from "./InternetRenewal.vue?vue&type=template&id=dd4070d8"
import script from "./InternetRenewal.vue?vue&type=script&lang=js"
export * from "./InternetRenewal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports